<template>
	<tr>
		<td>
			<span>{{ username }}</span>
		</td>
		<td>
			<span>{{ email }}</span>
		</td>
		<td>
			<span>{{ created }}</span>
		</td>
		<td class="actions">
			<!-- Edit -->
			<Action title="Edit" class="btn" @click="edit">
				<IconEdit />
			</Action>
			<!-- Delete -->
			<Action title="Delete" class="btn" @click="remove">
				<IconDelete />
			</Action>
		</td>
	</tr>
</template>

<script>
import Action from '@/components/shared/Action'
import IconEdit from 'mdi-vue/Pencil'
import IconDelete from 'mdi-vue/Delete'

export default {
	name: 'AdminAccountsTableRow',
	props: {
		id: Number,
		username: String,
		email: String,
		created_at: String,
		updating: Boolean
	},
	computed: {
		created() {
			return new Date(this.created_at).toLocaleDateString()
		}
	},
	methods: {
		edit() {
			this.$router.push({
				name: 'Edit Admin Account',
				params: { id: this.id }
			})
		},
		remove() {
			this.$emit('remove', {
				id: this.id,
				username: this.username,
				email: this.email
			})
		}
	},
	components: {
		Action,
		IconEdit,
		IconDelete
	}
}
</script>
